var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26855 15.7499C5.26731 14.8605 5.44213 13.9795 5.78294 13.1579C6.12375 12.3363 6.62381 11.5903 7.25429 10.9628C7.88476 10.3353 8.6332 9.83889 9.45644 9.50204C10.2797 9.16519 11.1615 8.99461 12.0509 9.00013C15.7625 9.02772 18.7312 12.1128 18.7312 15.8347V16.4999C18.7312 19.8577 19.4337 21.8061 20.0524 22.871C20.1191 22.9848 20.1546 23.1142 20.1553 23.246C20.156 23.3779 20.1219 23.5076 20.0565 23.6221C19.991 23.7366 19.8966 23.8318 19.7826 23.8982C19.6686 23.9645 19.5392 23.9996 19.4073 23.9999H4.59173C4.45985 23.9996 4.33038 23.9645 4.2164 23.8981C4.10242 23.8318 4.00795 23.7366 3.94252 23.622C3.8771 23.5075 3.84303 23.3778 3.84376 23.2459C3.84449 23.114 3.87999 22.9846 3.94667 22.8709C4.56573 21.8059 5.26855 19.8575 5.26855 16.4999L5.26855 15.7499Z",
    stroke: "#0E5AA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 24V24.75C9 25.5456 9.31607 26.3087 9.87868 26.8713C10.4413 27.4339 11.2044 27.75 12 27.75C12.7956 27.75 13.5587 27.4339 14.1213 26.8713C14.6839 26.3087 15 25.5456 15 24.75V24",
    stroke: "#0E5AA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.87f50d439f4fdac150fb40829332d607cf57133e19dfea6fa032db4f090d828a.svg";
export { ForwardRef as ReactComponent };